import React from 'react'
import SwitchUnstyled from '@mui/base/SwitchUnstyled'
import './Switch.scss'

const Switch = props => <SwitchUnstyled className="MuiSwitch-root" {...props} />

export default Switch
